import React, { useState, useEffect } from 'react';

import Header from '../Header';
import Footer from '../Footer';

const Crm = () => {
  const [scrolled, setScrolled] = useState(false);
  const Crm =require("../../Images/Crm.jpg")

  // Scroll event handler to track user's scroll position
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 100) {
      setScrolled(true);  // Add the scrolled class after 100px scroll
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const bulletPoints = [
    'Contact Management',
    'Flexible Security & Access Permissions',
    'Billing & Invoicing Functionality',
    'Data Reporting',
    'Mobile CRM including a Mobile App and Alerts',
    'Sales Performance Management'
  ];
  
  

  return (
    <>
    <Header/>
    <h2 className="pos-heading">Customer Relationship Management (CRM)</h2>
    <div className={`product ${scrolled ? 'scrolled' : ''}`}>
      <div className="product-image-wrapper">
        <img src={Crm} alt="Product" className="product-image" />
      </div>
      <div className="product-content">
        <ul className="bullet-points">
          {bulletPoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Crm;
